{
  "upload": {
    "absent": {
      "text": "Vous n'avez pas de licence active."
    },
    "text": "Déposer votre fichier de licence",
    "title": "Cliquez ici pour sélectionner et déposer un fichier de licence",
    "dropInformation": "Déposez la licence ici ou cliquez ici pour lancer la sélection",
    "validation": {
      "fileMandatory": "Le fichier doit être un .JWT ou un .OPL",
      "fileEmpty": "Le fichier ne doit pas être vide",
      "fileSize": "La taille du fichier doit être inférieure à 750Mo"
    },
    "new": {
      "text": "Déposer un nouveau fichier de licence",
      "title": "Cliquez ici pour sélectionner et déposer un nouveau fichier de licence"
    },
    "loading": "Chargement ...",
    "success": "Licence valide",
    "errors": {
      "signature_invalid": "Une erreur de signature du fichier de licence a été détectée.",
      "license_id_already_exists": "L’identifiant de la licence est similaire.",
      "platform_id_not_match": "L’identifiant de la plateforme ne correspond pas.",
      "organization_id_not_match": "L’identifiant de l’organization ne correspond pas.",
      "expires_contracted_invalid": "La date d’expiration est inférieure à la date courante.",
      "expires_tolerate_invalid": "La date d’expiration n’est pas conforme à l’attendu.",
      "max_devices_total_value_invalid": "Le nombre d'équipement total n’est pas conforme à l’attendu.",
      "max_devices_total_contracted_expires_invalid": "Le nombre d'équipement est inférieur à la valeur courante de l’organisation.",
      "max_devices_total_tolerated_expires_invalid": "Le nombre d'équipement total n’est pas conforme à l’attendu.",
      "max_devices_by_type_value_invalid": "Le nombre d'équipement total n’est pas conforme à l’attendu.",
      "max_devices_by_type_contracted_expires_invalid": "Le nombre d'équipement est inférieur à la valeur courante de l’organisation.",
      "max_devices_by_type_tolerated_expires_invalid": "Le nombre d'équipement total n’est pas conforme à l’attendu.",
      "feature_value_invalid": "Les fonctionnalités de la licence ne sont pas conforme à l’attendu.",
      "schema_not_match": "Une erreur de format du fichier de licence a été détectée sur les informations suivantes : {field}"
    }
  },
  "status": {
    "title": "Statut de la licence :",
    "active": "Active",
    "notActive": "Pas encore active",
    "warning": "Avertissement",
    "expired": "Expirée"
  },
  "characteristics": {
    "title": "Caractéristiques",
    "date": {
      "validated": "Date de validité :",
      "validatedOn": "Validée le {date}",
      "start": "Date de démarrage :",
      "end": "Date d'expiration :"
    },
    "id": "Identifiant de la licence :"
  },
  "idCard": {
    "title": "Informations nécessaires pour obtenir une licence",
    "description": "Ces identifiants sont utilisés pour générer les licences.",
    "export": {
      "title": "Exporter la carte ID",
      "text": "Exporter la carte ID"
    },
    "download": "Télécharger la carte ID"
  },
  "overlay": {
    "title": {
      "notFound": "Votre organisation requiert une license",
      "expired": "Votre license a expiré"
    },
    "message": {
      "notFound": "Afin d’exploiter votre organisation, merci d’insérer une licence. L’accès sera bloqué tant qu’un fichier valide ne sera pas présent.",
      "expired": "Afin de poursuivre l’exploitation, merci de renouveler votre licence. L’accès est temporairement bloqué en attente de la régularisation."
    }
  },
  "gauge": {
    "device": {
      "warning": {
        "tooltip": "Vous avez dépassé la limite du nombre d'équipements autorisés par votre licence",
        "message": "Seuil atteint"
      },
      "error": {
        "tooltip": "Aucun équipement additionnel ne pourra être provisionné sur la plateforme",
        "message": "Limite atteinte"
      }
    }
  },
  "deviceTypes": {
    "title": "Seuils des équipements"
  },
  "withoutLimits": "Sans limite",
  "total": "Total",
  "features": {
    "title": "Limites de la licence",
    "interfaces_third_party": "Interfaces",
    "warning": {
      "tooltip": "Vous avez dépassé la limite de votre licence"
    },
    "error": {
      "tooltip": "La création de nouvelle ressources est désactivée"
    }
  },
  "warning": {
    "title": "Limite de licence atteinte.",
    "expirationDateExceeded": "Vous avez dépassé la date d’expiration de votre licence. Veuillez renouveler votre licence avant l’interruption du service.",
    "devicesCountExceeded": "Vous avez dépassé le nombre d'appareils autorisés dans votre licence actuelle. Certaines fonctionnalités peuvent être limitées jusqu'à régularisation de la situation.",
    "redirect": "Voir le panel licence"
  }
}
